export default __webpack_public_path__ + "images/search-icon (1).svg";